module.exports = __webpack_public_path__ + "img/icon-christmas-8.94baa5fa.svg";